import { useConfirmingRequestOverview } from 'lib/api/confirming';
import type { ConfirmingDocumentOverview } from 'lib/api/confirming/types';
import { formatMoney, getShortString } from 'lib/functions/utils';
import type { StatusLightType } from 'lib/mobileDesignSystem';
import type { DocumentPageItem } from 'pages/mobile/Finance/shared/DocumentsPage';
import SharedDocumentsPage from 'pages/mobile/Finance/shared/DocumentsPage';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

function mapDocumentToItem(
  document: ConfirmingDocumentOverview,
  index: number,
): DocumentPageItem {
  return {
    key: `document-${document.folio}-${index}`,
    primaryText: getShortString(document.stakeholderName, 20),
    secondaryText: `${document.folio} · ${document.type}`,
    amount: formatMoney(document.amountDocument),
    statusLights: [
      { type: document.paidAtState as StatusLightType, label: 'Pagado' },
      {
        type: (document.creditNotesDate
          ? 'error'
          : 'success') as StatusLightType,
        label: 'NC',
      },
      { type: document.ceddedState as StatusLightType, label: 'Cedida' },
      { type: document.cancelDateState as StatusLightType, label: 'Reclamos' },
      {
        type: document.confirmDateState as StatusLightType,
        label: 'Confirmada',
      },
    ],
  };
}

const Documents: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const requestId = id ?? '';

  const {
    data: operation,
    isLoading,
    isError,
  } = useConfirmingRequestOverview(dispatch, requestId);

  const documentItems = React.useMemo(
    () => (operation?.documents ?? []).map(mapDocumentToItem),
    [operation?.documents],
  );

  return (
    <SharedDocumentsPage
      isLoading={isLoading}
      isError={isError}
      notFound={!isLoading && !isError && !operation}
      documentItems={documentItems}
      onBack={() => navigate(-1)}
    />
  );
};

export default Documents;
